import React, { useEffect, useState } from 'react';

import {
  Breakpoints,
  Image,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';

import { ImageState, Vehicles } from '../../../typings/main';
import { checkImageLoads } from '../../../../shared/utils/general';
import {
  StyledImageWrapper,
  StyledPartialHeaderWrapper,
  StyledPartialImageWrapper,
  StyledPartialVehicleCardWrapper,
  StyledVehicleInformationContainer,
} from './styled';
interface PartialVehicleCardProps {
  id: string;
  vehicle: Vehicles;
  userRole: string;
}

export const PartialVehicleCard = ({
  id,
  vehicle,
  userRole,
}: PartialVehicleCardProps) => {
  const [imageState, setImageState] = useState<ImageState>({
    isValidUrl: false,
    imgUrl: '',
  });

  const representativeImgURLComplete = vehicle?.representativeImgURLComplete ?? '';
  const representativeImgURLPartial = vehicle?.representativeImgURLPartial ?? '';

  useEffect(() => {
    const validateImages = async () => {
      if (await checkImageLoads(representativeImgURLComplete)) {
        setImageState({
          isValidUrl: true,
          imgUrl: representativeImgURLComplete,
        });
        return;
      }

      if (await checkImageLoads(representativeImgURLPartial)) {
        setImageState({
          isValidUrl: true,
          imgUrl: representativeImgURLPartial,
        });
        return;
      }

      setImageState({
        isValidUrl: false,
        imgUrl: '',
      });
    };

    validateImages();
  }, [representativeImgURLComplete, representativeImgURLPartial]);

  if (!vehicle) return <></>;

  const { modelName, modelYear, vin } = vehicle;

  return (
    <StyledPartialVehicleCardWrapper key={`Partial-Vehicle-Image-${id}`}>
      <StyledPartialHeaderWrapper hasImage={imageState.isValidUrl}>
        <StyledVehicleInformationContainer>
          <TextCustom
            appearance={TextAppearance.label100}
            style={{
              [Breakpoints.default]: {
                fontSize: TextSize.TextSize12,
                fontWeight: TextWeight.bold,
                color: TextColor.secondary,
                lineHeight: TextLineHeight.TextLineHeight16,
              },
              [Breakpoints.b1920]: {
                fontSize: TextSize.TextSize14,
                fontWeight: TextWeight.bold,
                color: TextColor.secondary,
                lineHeight: TextLineHeight.TextLineHeight16,
              },
            }}
          >
            {userRole}
          </TextCustom>
          <TextCustom
            appearance={TextAppearance.headline200}
            style={{
              [Breakpoints.default]: {
                fontSize: TextSize.TextSize20,
                fontWeight: TextWeight.bold,
                color: TextColor.primary,
                lineHeight: TextLineHeight.TextLineHeight24,
              },
              [Breakpoints.b1920]: {
                fontSize: TextSize.TextSize24,
                fontWeight: TextWeight.bold,
                color: TextColor.primary,
                lineHeight: TextLineHeight.TextLineHeight28,
              },
            }}
          >
            {modelYear} {modelName}
          </TextCustom>
          <TextCustom
            appearance={TextAppearance.copy100}
            style={{
              [Breakpoints.default]: {
                fontSize: TextSize.TextSize14,
                fontWeight: TextWeight.light,
                color: TextColor.primary,
                lineHeight: TextLineHeight.TextLineHeight24,
              },
              [Breakpoints.b1920]: {
                fontSize: TextSize.TextSize16,
                fontWeight: TextWeight.light,
                color: TextColor.primary,
                lineHeight: TextLineHeight.TextLineHeight24,
              },
            }}
          >
            VIN {vin}
          </TextCustom>
        </StyledVehicleInformationContainer>
      </StyledPartialHeaderWrapper>
      {imageState.isValidUrl && (
        <StyledPartialImageWrapper>
          <StyledImageWrapper>
            <Image src={imageState.imgUrl} alt="vehicle-card" />
          </StyledImageWrapper>
        </StyledPartialImageWrapper>
      )}
    </StyledPartialVehicleCardWrapper>
  );
};
